/* merchant/actions */
import { action } from "typesafe-actions";
import { Merchant, MerchantActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(MerchantActionTypes.FETCH, { id, params, callback });

export const fetchAllRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(MerchantActionTypes.FETCH_ALL, { id, params, callback });

export const fetchSuccess = (data: Merchant) =>
  action(MerchantActionTypes.FETCH_SUCCESS, data);

export const fetchAllSuccess = (data: Merchant) =>
  action(MerchantActionTypes.FETCHALL_SUCCESS, data);

export const fetchError = (error: string) =>
  action(MerchantActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Merchant | null) => unknown
) => action(MerchantActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Merchant) =>
  action(MerchantActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(MerchantActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(MerchantActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(MerchantActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(MerchantActionTypes.DELETE_ERROR, error);

export const updateState = (data: Data[]) =>
  action(MerchantActionTypes.UPDATE_STATE, data);


export const downloadRequest = (
  params: { },
  callback?: (err?: string | null, data?: any | null) => unknown
) => action(MerchantActionTypes.DOWNLOAD_REQUEST, { params, callback });
